import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=24679872&scoped=true"
import script from "./Camera.vue?vue&type=script&lang=js"
export * from "./Camera.vue?vue&type=script&lang=js"
import style0 from "./Camera.vue?vue&type=style&index=0&id=24679872&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24679872",
  null
  
)

export default component.exports